import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

export const ChartLegendLabel = ({
    variant = 'neutral',
    shape = 'square',
    children,
    ...props
}) => {
    return (
        <div
            className="d-flex align-items-center mr-2"
            {...props}>
            <div
                className={clsx('dashboard-chart-legend', 'helix-flex-no-shrink', 'mr-2', {
                    'helix-bg-brand': variant === 'dark',
                    'helix-bg-brand-2': variant === 'medium',
                    'helix-bg-brand-3': variant === 'light',
                    'helix-gray-300': variant === 'neutral',
                    'helix-bg-blue': variant === 'blue',
                    'border-radius--rounded': shape === 'circle',
                    'dashboard-chart-square': shape === 'square',
                    'dashboard-chart-line': shape === 'line'
                })}
            />
            <div className="helix-legend-label">
                {children}
            </div>
        </div>
    );
};

ChartLegendLabel.propTypes = {
    children: PropTypes.string,
    variant: PropTypes.oneOf(['dark', 'medium', 'light', 'neutral', 'blue']),
    shape: PropTypes.oneOf(['circle', 'square', 'line'])
};
